import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import * as constants from 'irmlib/common/constants'
import { FlexByRow } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'

const AppliedFilters = styled(FlexByRow)`
  padding: 25px;
  margin: 20px;
  background: #F3F5F7;
`
const FilterName = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 15px;
`
const FilterValue = styled.div`
    max-height: 55px;
    max-width: 250px;
    overflow: hidden;
    overflow-y: auto;

`
const DisplayFilter = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 15px;
`
const VerticalLine = styled.div`
  border-left: 1px solid lightgrey;
  padding: 10px;
`

const DisplayAppliedFilters = (props) => {
  const { t } = useTranslation()
  const { accountLevel1 = '', allUsers, country, districtId, startDate, endDate } = props?.appliedFilters

  const displayDistrictId = []
  districtId.forEach((singleDistrictId, index) => {
    const splittedSingleDistrictId = singleDistrictId.split('-')
    if (splittedSingleDistrictId[1] !== 'ALL') {
      displayDistrictId.push(singleDistrictId)
    }
  })

  const deafaultEmployeeSelection = 'all-employees'
  return (<AppliedFilters>
    {<>
      {accountLevel1 && 
      <><DisplayFilter>
        <FilterName>{t('reports.filters.accountLevel')}</FilterName>
        <FilterValue>{accountLevel1.toUpperCase()}</FilterValue>
      </DisplayFilter>
        <VerticalLine />
      </>
      }
      {allUsers && allUsers !== deafaultEmployeeSelection &&
      <><DisplayFilter>
        <FilterName>{t('reports.filters.user')}</FilterName>
        <FilterValue>{allUsers}</FilterValue>
      </DisplayFilter>
        <VerticalLine />
      </>
      }
      {country && country !== constants.defaultSelect &&
      <><DisplayFilter>
        <FilterName>{t('reports.filters.country')}</FilterName>
        <FilterValue>{country}</FilterValue>
      </DisplayFilter>
        <VerticalLine />
      </>
      }
      {displayDistrictId?.length > 0 && 
      <>
        <DisplayFilter>
          <FilterName>{t('reports.filters.district')}</FilterName>
          <FilterValue>{displayDistrictId?.length > 1 ? displayDistrictId.join(', ') : displayDistrictId }</FilterValue>
        </DisplayFilter>
        <VerticalLine />
      </>
      }
      {startDate && 
      <>
        <DisplayFilter>
          <FilterName>{t('reports.filters.startDate')}</FilterName>
          <FilterValue>{startDate}</FilterValue>
        </DisplayFilter>
        <VerticalLine />
      </>
      }
      {endDate &&
        <>
          <DisplayFilter>
            <FilterName>{t('reports.filters.endDate')}</FilterName>
            <FilterValue>{endDate}</FilterValue>
          </DisplayFilter>
        </>
      } 
    </>}
  </AppliedFilters>
  )
}

export default DisplayAppliedFilters

DisplayAppliedFilters.propTypes = {
  appliedFilters: PropTypes.obj
}